import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-gallery-imagenes-videos',
  standalone: true,
  imports: [CommonModule,MatDialogModule],
  templateUrl: './modal-gallery-imagenes-videos.component.html',
  styleUrl: './modal-gallery-imagenes-videos.component.scss'
})
export class ModalGalleryImagenesVideosComponent {

  public image: any;
  gallery: any[] = [];
  titulo: string;
  descripcion: string | undefined;
  position: number;
  spinner = false;

  private touchStartX = 0;
  private touchEndX = 0;
  private minSwipeDistance = 50;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { titulo: string, gallery: any[]; position: number },
    private ref: ChangeDetectorRef,
  ) {
    this.titulo = data.titulo;
    this.gallery = data.gallery;
    this.position = data.position;
  }

  ngOnInit(): void {
     this.getImageSelected();
  }

  getImageSelected(): void {
    this.image = this.gallery[this.position];
  }
  changeImg(move: number): void {
    if (!this.gallery.length) {
      return;
    }

    // La posición vuelve al extremo opuesto al superar el inicio o el final.
    this.position = (this.position + move + this.gallery.length) % this.gallery.length;
    this.image = this.gallery[this.position];
  }

// --- Manejo del Swipe / Drag ---

  onTouchStart(event: TouchEvent): void {
    this.touchStartX = event.changedTouches[0].screenX;
  }

  onTouchEnd(event: TouchEvent): void {
    this.touchEndX = event.changedTouches[0].screenX;
    this.handleSwipe();
  }

  onMouseDown(event: MouseEvent): void {
    this.touchStartX = event.clientX;
  }

  onMouseUp(event: MouseEvent): void {
    this.touchEndX = event.clientX;
    this.handleSwipe();
  }

  private handleSwipe(): void {
    const swipeDistance = this.touchEndX - this.touchStartX;

    if (swipeDistance < -this.minSwipeDistance) {
      this.changeImg(1); // Siguiente imagen
    } else if (swipeDistance > this.minSwipeDistance) {
      this.changeImg(-1); // Imagen anterior
    }
  }

  ngOnDestroy(): void {
    this.gallery = [];
    this.image = null;
  }
}

